import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

import type { LinkedBroadcast } from "@/api/broadcastV2Audiences";

import { LinkedBroadcastsModalTable } from "@/components/LinkedBroadcastsModalTable";

interface LinkedBroadcastsSaveConfirmModalProps {
  open: boolean;
  broadcasts: LinkedBroadcast[];
  isSaving: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function LinkedBroadcastsSaveConfirmModal({
  open,
  broadcasts,
  isSaving,
  onCancel,
  onConfirm,
}: LinkedBroadcastsSaveConfirmModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="broadcast-save-title"
    >
      <DialogTitle id="broadcast-save-title">Save changes</DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          <Typography variant="body2" color="text.secondary">
            This tile is in use by the broadcast(s) below. Saving will apply
            your changes to their upcoming sends.
          </Typography>
          <LinkedBroadcastsModalTable broadcasts={broadcasts} />
        </Box>
      </DialogContent>
      <DialogActions sx={{ gap: 2, justifyContent: "flex-end", px: 4, pb: 3 }}>
        <Button
          variant="outlined"
          color="inherit"
          onClick={onCancel}
          disabled={isSaving}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          disabled={isSaving}
          startIcon={
            isSaving ? <CircularProgress size={16} color="inherit" /> : null
          }
        >
          {isSaving ? "Saving..." : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
